function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint class-methods-use-this: "off" */
import { GridMouseHandler } from '@deephaven/grid';
/**
 * Handles sending data selected via double click
 */
class IrisGridDataSelectMouseHandler extends GridMouseHandler {
  constructor(irisGrid) {
    super(880);
    _defineProperty(this, "irisGrid", void 0);
    this.irisGrid = irisGrid;
  }
  onDoubleClick(gridPoint, grid) {
    var column = gridPoint.column,
      row = gridPoint.row;
    if (row == null || column == null) {
      return false;
    }
    this.irisGrid.selectData(column, row);
    return false;
  }
}
export default IrisGridDataSelectMouseHandler;
//# sourceMappingURL=IrisGridDataSelectMouseHandler.js.map